<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_block"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				为全球提供 实惠 易用 精准 的诊断产品
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="search_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<van-icon name="search" size="20px" style="top: -1px;" />
						<input v-model="searchVal" placeholder="请输入搜索关键词" @keyup.enter="searchClick" />
						<div class="tit" @click="searchClick">搜索</div>
					</div>
					<div v-if="searchList.length > 0">
						<div class="list_box">
							<div class="tit_box"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="tit">搜索结果</div>
								<div class="txt">共 {{ total }} 条</div>
							</div>
							<div class="list_main">
								<div v-for="(value, index) in searchList" :key="index" class="list_el"
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="100"
									data-aos-offset="0"
									data-aos-once="true"
									@click="goInfo(value)"
								>
									<div class="tips">
										<div>{{ value.leixing == 'Products' ? '产品' : '新闻资讯' }}</div>
									</div>
									<div class="tit">{{ value.leixing == 'Products' ? value.name : value.title }}</div>
									<div class="bot_box">
										<div class="left">
											<img :src="webUrl + value.thumb" />
										</div>
										<div class="right">{{ value.content }}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="page_box"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<el-pagination
								:small="false"
								background
								layout="prev, pager, next"
								:total="total"
								:page-size="10"
								:pager-count="5"
								@current-change="pageChange"
							>
							</el-pagination>
						</div>
					</div>
					<div v-else
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<van-empty image="search" description="暂无数据~" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { UPURL } from '@/util/util'
import { searchList } from '@/api/public'
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			searchVal: '',
			page: 1,
			total: 0,
			searchList: [],
			webUrl: UPURL
		}
	},
	created(){
		let that = this;
		if(that.$route.query.search) {
			that.searchVal = that.$route.query.search;
			that.getList();
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击查看详情
		goInfo(value) {
			let that = this;
			if(value.leixing == 'Products') {
				that.$router.push({ name: 'ProductInfo', params: { productInfoId: value.id + '.html' } });
			}else {
				that.$router.push({ name: 'NewsInfo', params: { newInfoId: value.id + '.html' } });
			}
		},
		//点击搜索
		searchClick() {
			let that = this;
			if(that.searchVal) {
				that.getList();
			}else {
				that.$toast('请输入您想搜索的内容');
			}
		},
		//分页点击
		pageChange(val) {
			let that = this;
			that.page = val;
			that.getList();
		},
		//搜索
		getList() {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			searchList({
				page: that.page,
				page_size: 10,
				keyword: that.searchVal,
				language: sessionStorage.getItem('lang')
			}).then(res => {
				that.searchList = res.data.data;
				that.total = res.data.total;
				that.$toast.clear();
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		background: url(../../assets/img_public/search/block_bg_h5.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_1_main{
			padding: 30px 20px;
			.page_box{
				padding-bottom: 30px;
				text-align: center;
			}
			.list_box{
				padding: 30px 0;
				.list_main{
					padding-top: 30px;
					.list_el{
						margin-bottom: 12px;
						padding: 16px;
						background-color: #ffffff;
						border-radius: 8px;
						.tips{
							padding-bottom: 10px;
							text-align: right;
							div{
								display: inline-block;
								font-size: 12px;
								padding: 4px 12px 2px 12px;
								border-radius: 16px;
								background-color: #efefef;
								color: #A50073;
							}
						}
						.bot_box{
							display: flex;
							align-items: center;
							padding-top: 12px;
							.right{
								flex: 1;
								padding-left: 12px;
								font-size: 12px;
								color: #666666;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 4;
								-webkit-box-orient: vertical;
							}
							.left{
								width: auto;
								img{
									width: 80px;
								}
							}
						}
						.tit{
							font-size: 16px;
						}
					}
				}
				.tit_box{
					.txt{
						padding-top: 4px;
					}
					.tit{
						font-size: 20px;
					}
				}
			}
			.search_box{
				position: relative;
				padding: 0 24px 0 16px;
				background-color: #ffffff;
				border: 1px solid #A50073;
				border-radius: 8px;
				display: flex;
				align-items: center;
				input{
					flex: 1;
					height: 38px;
					color: #A50073;
					border: none;
					padding: 0px 5px;
					user-select: none;
				}
				.tit{
					width: auto;
					font-size: 16px;
					line-height: 1;
					color: #A50073;
				}
			}
		}
	}
	.banner_block{
		width: 100%;
		height: 60px;
		line-height: 60px;
		background: linear-gradient( 90deg, #A50073 0%, #C7007E 49%, #A50073 100%);
		text-align: center;
		color: #ffffff;
		font-size: 16px;
	}
}
</style>
<style scoped>
/*分页*/
>>> .page_box .el-pagination {
  max-width: 100%; /* 最大宽度为屏幕宽度 */
}

>>> .page_box .el-pager li:hover{
	color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #A50073 !important;
}
>>> .page_box .el-pagination.is-background .el-pager li:not(.disabled).active:hover{
	color: #ffffff !important;
}
</style>